import { Dispatch, SetStateAction, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { TrackingProperties } from "store/config";
import { UseInput } from "hooks";

import { Input, InputDTO } from "components/common/input/Input";

import classes from "./Form.module.scss";

export interface FormState {
  [key: string]: UseInput;
}

export interface FormProps {
  fields: TrackingProperties[];
  layoutClass?: string[];
  values?: any;
  formStateSetter: Dispatch<SetStateAction<FormState | undefined>>;
  genericValidation?: boolean;
}

export const Form: React.FC<FormProps> = ({
  fields,
  formStateSetter,
  values,
  layoutClass = ["Form_Field"],
  genericValidation,
}) => {
  const { t } = useTranslation();
  layoutClass.forEach((cls, i) => {
    layoutClass[i] = classes[cls];
  });

  const makeFirstCharLower = (value: string) => {
    return value[0].toLowerCase() + value.slice(1);
  };

  const setFormData = useCallback(
    (key: string, val: UseInput) => {
      formStateSetter((state: FormState | undefined) => {
        return {
          ...state,
          [key]: val,
        };
      });
    },
    [formStateSetter],
  );

  const renderFields = (fields: InputDTO[]) => {
    return fields.map((field: InputDTO, i) => {
      return (
        <div key={i} className={layoutClass.join(" ")}>
          <Input
            id={field.key}
            passState={setFormData}
            label={field.label}
            val={field.val}
            validationMessage={field.validationMessage}
            extraProp={field.extraProp}
            type={field.type}
            options={field.options}
            datacy={`custom-form-input${field.label}`}
            data-testid="acc-num-first-field"
          />
        </div>
      );
    });
  };

  const createLookUpFormObj = () => {
    let validationProps: any = {};
    if (genericValidation) {
      validationProps.maxLength = 50;
    }
    // return paymentCenter.quickPayTrackingProperties.map((single) => {
    return fields.map((single) => {
      return {
        label: single.displayName,
        key: single.propertyName,
        val: values ? values[makeFirstCharLower(single.propertyName)] : "",
        validationMessage: t("common:invalid_field_generic"),
        extraProp: {
          required: true,
          ...validationProps,
        },
      };
    });
  };

  return <>{renderFields(createLookUpFormObj())}</>;
};
